import { useMemo } from 'react';
import {
  useGameCardsAnimation,
  useGetPlatformForFeed,
  useIsSectionVisible
} from '../../hooks';
import { INormalizedGame } from '../../types';

// fix after device context is in ts
export const useGamesListAnimation = (
  gamesList: INormalizedGame[],
  showAnimation?: boolean
) => {
  const platform: string = useGetPlatformForFeed();

  const gameIdsWithAnimationImage = useMemo(
    () =>
      gamesList
        .filter((game) => game.animatedImage)
        .map(({ gameId }) => gameId),
    [gamesList, platform]
  );

  const shouldGameAnimationLogicBeActive =
    gameIdsWithAnimationImage.length && showAnimation;

  const { isVisible: isSectionVisibleInViewport, sectionRef } =
    useIsSectionVisible(0.1);

  const currentAnimatedGameId = useGameCardsAnimation(
    gameIdsWithAnimationImage,
    isSectionVisibleInViewport
  );
  return {
    currentAnimatedGameId,
    shouldGameAnimationLogicBeActive,
    sectionRef
  };
};
